import { wsName } from "@wingspanhq/utils/dist/name/wsName";

import { useUserId } from "../../../../../query/hooks/helpers";
import {
  useQueryMemberProfile,
  useQueryUserProfile
} from "../../../../../query/users/queries";

/**
 * The signed-in contractor's own display name, resolved the same way the
 * named-insured check resolves it on the backend (`wsName` over user and
 * member). Read by the upload flow, which narrates the mismatch with both
 * names before the contractor imports.
 */
export const useContractorProfileName = (
  enabled = true
): string | undefined => {
  const userId = useUserId();
  const queryUser = useQueryUserProfile(userId, {
    enabled: enabled && !!userId
  });
  const queryMember = useQueryMemberProfile(userId, {
    enabled: enabled && !!userId
  });

  if (!queryUser.data) {
    return undefined;
  }

  return (
    wsName({
      user: queryUser.data,
      member: queryMember.data
    }).getResolvedName() || undefined
  );
};
